var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("plans-section"),
      _c("payment-guarantee-section", {
        attrs: {
          title: `${_vm.$t(
            "pages.pricing.paymentGuarantee.daysMoneyBackGuaranteeNoQuestionsAsked",
            { days: "15" }
          )}`,
          description: `${_vm.$t(
            "pages.pricing.paymentGuarantee.notFullySatisfiedWithIdeaBuddy",
            { days: "15", email: "support@ideabuddy.com" }
          )}`,
          "money-back-image": require("@/assets/img/pricing/payment-guarantee/badge-money-back.svg"),
        },
      }),
      _c("pricing-for-special-groups-section"),
      _c("idea-is-safe-section"),
      _c("capterra-reviews-section"),
      _c("faq-section"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }